import { Component, OnInit, signal, WritableSignal } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { UserService } from 'src/app/services/user.service'
import { User } from 'src/types/user'
import { MobileMenuComponent } from '../mobile-menu/mobile.menu.component'
import { MatButtonModule } from '@angular/material/button'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatMenuModule } from '@angular/material/menu'

@Component({
	selector: 'gwc-layout',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.scss'],
	imports: [
		MobileMenuComponent,
		MatButtonModule,
		MatToolbarModule,
		MatMenuModule,
		RouterModule
	]
})

export class LayoutComponent implements OnInit {
	public user: WritableSignal<User | null> = signal<User | null>(null)

	constructor(
		private userService: UserService,
		public router: Router
	) { }

	ngOnInit(): void {
		this.checkUser()
	}

	private checkUser(): void {
		this.userService.check()
			.subscribe((response: User) => {
				this.user.set(response)
			})
	}

	public logout(): void {
		this.userService.logout()
			.subscribe(() => this.router.navigate(['/login']))
	}
}
